import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetOtherKeywordsFromWiresUsingKeyword(keywords, limit) {
  const searchQueryId = window.Livewire?.request?.searchQuery?.id;
  return useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/keywords/other',
    method: 'GET',
    params: { keywords, search_query_id: searchQueryId, top: limit },
  }, { manual: true });
}
